import { render, staticRenderFns } from "./EditExamsModal.vue?vue&type=template&id=b1429d62&scoped=true&"
import script from "./EditExamsModal.vue?vue&type=script&lang=js&"
export * from "./EditExamsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1429d62",
  null
  
)

export default component.exports